export const DATAPOINT_SOURCES = {
  LUSHA: 'lusha',
  EDITED: 'edited',
  MANUALLY_ADDED: 'manually_added',
};

export const DATAPOINT_STATUS = {
  UPDATED: 'updated',
  ADDED: 'added',
  REMOVED: 'removed',
};

export const DATAPOINT_FIELD_KEYS = {
  WORK_EMAIL: 'workEmail',
  PRIVATE_EMAIL: 'privateEmail',
  PHONE: 'phone',
  COMPANY: 'company',
};
